<script>
  import { VHover, VListItem } from 'vuetify/lib'
  import vuetify from '../../plugins/vuetify'

  export default {
    name: 'AppBarItem',

    render (h) {
      return h(VHover, {
        scopedSlots: {
          default: ({ hover }) => {
            return h(VListItem, {
              attrs: this.$attrs,
              class: {
                'white--text': !hover && vuetify.framework.theme.dark,
                'black--text': !hover && !vuetify.framework.theme.dark,
                'white--text primary elevation-4': hover,
              },
              props: {
                activeClass: '',
                dark: hover,
                link: true,
                ...this.$attrs,
              },
            }, this.$slots.default)
          },
        },
      })
    },
  }
</script>
